<div class="modall">
  <div class="modal-contentt">
    <video (ended)="onVideoEnded()" class="videoPlayerFullModal" id="video-player"
      width="100%" height="100%" controls autoplay muted playsinline>
      <source src="../../assets/images/videoSample.mp4" type="video/mp4">
    </video>
    <button class="closeBtn" (click)="onVideoEnded()">
      <img src="../../../../../assets/images/close.png" alt="">
    </button>
  </div>
</div>